import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";

import { ApiClient } from "/api/client";
import { useRouter } from "next/router";
import MaperOld from "../../pages/contacts/maperOld";

import styles from "./index.module.scss";

/** ПВЗ всех ТК в плоский список для карты (MaperOld). Пункты из соседних
 * городов уже отсеяны на BFF (pages/api/client/edost/getOffices.ts). */
function flattenOffices(offices) {
  if (!offices || typeof offices !== "object") {
    return [];
  }
  return Object.values(offices).flat();
}

/** Карта ПВЗ eDost для выбранного города. */
export default function EdostMap({ isBaltex }) {
  const { cityName, deliveryCityData, deliveryCityDataLoaded } = useSelector(
    (state) => state.location,
  );

  const [edostPoints, setEdostPoints] = useState([]);
  const router = useRouter();
  useEffect(() => {
    if (!deliveryCityDataLoaded) {
      setEdostPoints([]);
      return;
    }

    (async () => {
      const offices = await ApiClient.edost.getOffices(
        {
          city: cityName,
          region: deliveryCityData?.region ?? "",
          zip: deliveryCityData?.postal_code ?? "",
        },
        Boolean(router.query.reset),
      );
      setEdostPoints(flattenOffices(offices));
    })();
  }, [
    cityName,
    deliveryCityData?.region,
    deliveryCityData?.postal_code,
    deliveryCityDataLoaded,
  ]);

  return (
    <div className={clsx(styles.Adreses, isBaltex && styles.AdresesBaltex)}>
      <div className={styles.Map}>
        <MaperOld zoom={10} points={edostPoints} />
      </div>
    </div>
  );
}
